import React, { useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import SendIcon from "@mui/icons-material/Send";
import styles from "./styles.module.css";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import ResponsivContent from "../../components/ResponsivContent";
import { enviarTokenRedefinicaoDeSenha } from "../../services/auth.service";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);

  const handleOpenSnackbarSucesso = () => setOpenSnackbarSucesso(true);
  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => setOpenSnackbarErro(true);
  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbarErro(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await enviarTokenRedefinicaoDeSenha({ email });
      setMsg(response.mensagem);
      handleOpenSnackbarSucesso();
    } catch (error) {
      setMsg(error.response?.data?.mensagem || "Erro ao enviar e-mail.");
      handleOpenSnackbarErro();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <ResponsivContent>
        <section className={styles.containerSection}>
          <div className={styles.title}>
            <h2>Esqueci minha senha</h2>
          </div>

          <TextField
            label="E-mail"
            className={styles.emailTextField}
            fullWidth
            size="small"
            variant="outlined"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />

          <div className={styles.container__buttons}>
            <Button
              className={styles.botao__enviar}
              fullWidth
              type="submit"
              variant="contained"
              startIcon={<SendIcon />}
              onClick={handleSubmit}
              disabled={!email || loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Enviar"
              )}
            </Button>
          </div>
        </section>
      </ResponsivContent>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
